<template>
  <div v-if="primaryEvents.length > 0" class="grid generic-container">
    <div class="xs-12">
      <div class="grid">
        <h2 class="xs-8 dea-heading--medium__ml">
          Pacchetto: {{ registration.linked_event.title }}<br />
          <div v-if="registration.linked_event.description" class="dea-heading--regular__xm">
            {{ registration.linked_event.description }}
          </div>
        </h2>
        <div
          v-if="+registration.attendance_seconds"
          class="xs-12 l-4 ticket-container__buttons-container ticket-container__buttons-container--package"
        >
          <Links
            v-if="registration.sofia_certificate_available"
            class="dea-links--small dea-link--color-secondary-formazione dea-button--full dea-links--pointer"
            target="_blank"
            >Vai all'attestato S.O.F.I.A.</Links
          >
          <Buttons
            v-if="
              registration.is_active &&
                registration.past &&
                registration.is_event_time_reached &&
                !registration.survey_completed_date &&
                registration.linked_event.has_survey &&
                registration.dea_certificate_is_allowed &&
                !registration.dea_certificate_available
            "
            class="dea-button--large dea-button--full dea-button--iconRight"
            icon="go-to"
            @click="$emit('completeSurvey', registration)"
            >Compila il questionario e scarica l'attestato</Buttons
          >
          <Buttons
            v-if="registration.dea_certificate_available && registration.dea_certificate_url"
            class="dea-button--large dea-button--full dea-button--iconRight"
            icon="download"
            type="a"
            :href="registration.dea_certificate_url"
            target="_blank"
            >Scarica attestato</Buttons
          >
        </div>
      </div>
    </div>
    <div class="xs-12 generic-container__ticket-card-container">
      <TicketCard
        v-for="item in primaryEvents"
        :key="item.id"
        :registration="item"
        :editable="editable"
        :cancellable="false"
        @editLaboratories="$emit('editLaboratories', item)"
        @completeSurvey="$emit('completeSurvey', item)"
        @downloadFiles="$emit('downloadFiles', item)"
      ></TicketCard>
    </div>
    <div
      v-if="ticketFilter === 'future' && secondaryEvents.length"
      class="xs-12 dea-heading--regular__xm generic-container__list-intro"
    >
      Nel pacchetto, a cui ho già partecipato:
    </div>
    <div v-else-if="secondaryEvents.length" class="xs-12 dea-heading--regular__xm generic-container__list-intro">
      Nel pacchetto, a cui ancora non ho partecipato:
    </div>
    <div class="xs-12 generic-container__list-events">
      <template v-for="(packageRegistration, index) in secondaryEvents">
        <div :key="`${index}-registration-${packageRegistration.id}`">
          <Links
            v-if="ticketFilter === 'future'"
            :key="packageRegistration.id"
            class="dea-links--pointer dea-links--align-left dea-links--no-border"
            @click.native="changeState('past')"
            ><span class="dea-heading--medium__m">{{ packageRegistration.linked_event.title }}</span></Links
          >
          <Links
            v-else
            :key="packageRegistration.id"
            class="dea-links--pointer dea-links--align-left dea-links--no-border dea-heading--medium__m"
            @click.native="changeState('future')"
            ><span class="dea-heading--medium__m">{{ packageRegistration.linked_event.title }}</span></Links
          >
        </div>
      </template>
    </div>
    <div v-if="unAttendedEvents.length" class="xs-12 dea-heading--regular__xm generic-container__list-intro">
      Nel pacchetto, a cui non ho partecipato:
    </div>
    <div class="xs-12 generic-container__list-events">
      <template v-for="(packageRegistration, index) in unAttendedEvents">
        <div :key="`${index}-registration-${packageRegistration.id}`">
          <Links
            :key="packageRegistration.id"
            class="dea-links--pointer dea-links--align-left dea-links--no-border"
            @click.native="changeState('notAttended')"
            ><span class="dea-heading--medium__m">{{ packageRegistration.linked_event.title }}</span></Links
          >
        </div>
      </template>
    </div>
    <div class="xs-12 generic-container__detail-link">
      <Links v-if="false" class="dea-links--pointer dea-links--align-left dea-links--color-secondary-formazione"
        >Dettagli sull'ordine</Links
      >
    </div>
  </div>
</template>

<script>
import Links from "@/components/elements/Links";
import Buttons from "@/components/elements/Buttons";
import TicketCard from "~/components/events/components/TicketCard";

export default {
  name: "TicketPackage",
  components: {
    Links,
    TicketCard,
    Buttons,
  },
  props: {
    registration: {
      type: Object,
      default: () => ({}),
    },
    ticketFilter: {
      type: String,
      default: "",
    },
    packageChildren: {
      type: Array,
      default: () => [],
    },
    editable: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    primaryEvents() {
      return this.packageChildren.filter(element => {
        if (this.ticketFilter === "festival") {
          return true;
        }
        if (this.ticketFilter === "future") {
          return !element.past;
        }
        return element.past && element.is_event_attended;
      });
    },
    secondaryEvents() {
      return this.packageChildren.filter(element => {
        if (this.ticketFilter === "festival") {
          return false;
        }
        if (this.ticketFilter === "future") {
          return element.past && element.is_event_attended;
        }
        return !element.past;
      });
    },
    unAttendedEvents() {
      return this.packageChildren.filter(element => {
        return element.past && !element.is_event_attended;
      });
    },
  },
  methods: {
    changeState(ticketFilter) {
      this.$emit("changeState", ticketFilter);
    },
  },
};
</script>
<style lang="scss">
@import "@/styles/system.utils";

.generic-container {
  border: $border-bold $dea-color-target-magenta-formazione;
  margin-bottom: $space-large !important; //sass-lint:disable-line no-important
  padding: 0 $space-small;

  &__ticket-card-container {
    margin-top: $space-large;
  }

  &__list-intro {
    margin-bottom: $space-x-small;
  }

  &__list-events {
    & > * {
      margin-bottom: $space-small;
    }
  }

  &__detail-link {
    margin-top: $space-small;
  }
}

.ticket-container__buttons-container--package {
  padding: $space-small 0 0;
}
</style>
